module.exports = __webpack_public_path__ + "static/img/AO.262e05b5.jpg";